const moduleoptions = {
	title: "Modul tilvalg",
	new_moduleoption: "Nytt tilvalg",
	edit_moduleoption: "Modul tilvalg: {name}",
	id: "ID",
	moduletemplate_id: "Modul",
	coursetemplate_id: "Kursmal",
	name: "Navn",
	price: "Pris",
	enrol_select: "Velg ved påmelding",
	hours: "Timer",
	mandatory_accomplishment: "Obligatorisk tilvalg for gjennomføring",
	comment: "Kommentar",
	moduleoption_id: "Module valg",
	enrol_select_disable: "Skjul I påmelding er valgt for modul. Dette valget er ikke tilgjengelig. Modul må være synlig i påmelding.",
	accomp_select_disable: "Skjul I progresjon er valgt for modul. Dette valget er ikke tilgjengelig. Modul må være synlig i progresjon.",
};
export default moduleoptions;